import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../constants/routePaths';
import { Box, CircularProgress, Typography } from '@mui/material';
import { ModelDetailView } from '../../components/ModelDetailView';
import { modelService } from '../../services/ModelService';

interface Model {
  id: string;
  model_name: string;
  version: string;
  provider: string;
  description: string;
  type: string;
  size?: string;
  status: string;
  icon: string;
  iconBg: string;
  featured?: boolean;
  capabilities?: string[];
  pricing: {
    input: string;
    output: string;
  };
}

export function ModelViewPage() {
  const { modelId } = useParams<{ modelId: string }>();
  const navigate = useNavigate();
  const [model, setModel] = useState<Model | null>(null);

  useEffect(() => {
    modelId && fetchData(modelId)
  }, []);

  const fetchData = async (modelId: string) => {
    try {
      const foundModel: any = await modelService.getModelById(modelId);
      if (foundModel) {
        setModel(foundModel as Model);
      } else {
  navigate(ROUTE_PATHS.CATALOG);
      }
    } catch (error) {
      console.error('Error fetching deployment instances:', error);
    }
  };

  const handleClose = () => {
  navigate(ROUTE_PATHS.CATALOG);
  };

  if (!model) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          bgcolor: 'grey.50',
        }}
      >
        <CircularProgress size={48} />
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          Loading model details...
        </Typography>
      </Box>
    );
  }

  return (
    <ModelDetailView
      model={model}
      onClose={handleClose}
      // onDeploy={onDeploy}
    />
  );
}